import { render, staticRenderFns } from "./AnalyzeConceptBranch.vue?vue&type=template&id=152b07ca&scoped=true&"
import script from "./AnalyzeConceptBranch.vue?vue&type=script&lang=ts&"
export * from "./AnalyzeConceptBranch.vue?vue&type=script&lang=ts&"
import style0 from "./AnalyzeConceptBranch.vue?vue&type=style&index=0&id=152b07ca&prod&lang=scss&scoped=true&"
import style1 from "./AnalyzeConceptBranch.vue?vue&type=style&index=1&id=152b07ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152b07ca",
  null
  
)

export default component.exports